import { ReactElement, useEffect, useState } from 'react';
import { RightOutlined, LeftOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { Button } from 'common/components/antd/Button/Button';

export const ScrollerComponent = ({
  onScroll,
  node,
  delta = 150,
}: {
  onScroll?: (delta: number) => void;
  node: Element;
  delta: number;
}): ReactElement => {
  const [, forceUpdate] = useState(true);

  const scrollNode = (delta_: number): void => {
    const currentLeft = node.scrollLeft;

    node.scroll({
      left: currentLeft + delta_,
      behavior: 'smooth',
    });
    onScroll?.(delta_);
  };

  useEffect(() => {
    let scrollTimeout: NodeJS.Timer;
    const onScrollListener = (): void => {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        forceUpdate((prev) => !prev);
      }, 100);
    };

    node.addEventListener('scroll', onScrollListener);

    return (): void => {
      node.removeEventListener('scroll', onScrollListener);
    };
  }, []);

  const scrollable = node.scrollWidth > node.clientWidth;
  const endReached = node.scrollLeft + node.clientWidth >= node.scrollWidth;
  const startReached = node.scrollLeft === 0;

  return (
    <Space size={8}>
      <Button
        onClick={(): void => {
          scrollNode(-delta);
        }}
        disabled={startReached}
        icon={<LeftOutlined />}
      />
      <Button
        onClick={(): void => {
          scrollNode(delta);
        }}
        disabled={!scrollable || endReached}
        icon={<RightOutlined />}
      />
    </Space>
  );
};
